const searchConfig = {
  PARAM_NAME: "query",
  SEARCH_PLACEHOLDER: "Пошук за назвою, брендом, артикулом, кодом..",
};

export { searchConfig };
